import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { activateUserRequest, banUserRequest, clearUserErrors, clearUserSuccess, deleteUserRequest, fetchAgenciesRequest, fetchGroupsRequest, fetchUsersKpiRequest, fetchUsersRequest, openEditPage, verifyUserRequest } from "../../store/actions";
import { setUserBan } from "../../helpers/backend_helper";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../../components/ui/List/TableContainer";
import Breadcrumb from "../../components/ui/Breadcrumbs";
import { getCurrentTheme } from "../../utils/utils";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

const Users = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const parameters = useSelector(state => state.Parameters);
  document.title = `${t('users')} | ${parameters.appName}`; //meta title

  const { users, companies, userAdded, errorUser } = useSelector(state => state.Users);
  const { groups } = useSelector(state => state.Groups);
  const [groupsFormatted, setGroupsFormatted] = useState([]);
  const agencies = useSelector(state => state.Agencies.agencies);

  const [formattedAgencies, setFormattedAgencies] = useState([]);


  useEffect(() => {
    dispatch(fetchUsersRequest());
    dispatch(fetchGroupsRequest());
    dispatch(fetchAgenciesRequest());
  }, [dispatch]);

  const verifyUser = (item) => {
    // Dispatch an action to verify the user
    dispatch(verifyUserRequest(item.id));
  };

  const activateUser = (item) => {
    // Dispatch an action to verify the user
    dispatch(activateUserRequest(item.id));
  };


  useEffect(() => {
    if (groups) {
      let newGroups = groups.map((group) => {
        return {
          id: group.id,
          label: group.lib
        }
      });
      setGroupsFormatted(newGroups);
    }
  }, [groups]);

  useEffect(() => {
      if (agencies) {
        let newAgencies = agencies.map((agency) => {
          return {
            id: agency.id,
            label: agency.lib
          }
        });
        setFormattedAgencies(newAgencies);
      }
    }, [agencies]);

  // Configuration des colonnes
  const columnConfig = [
    { key: 'id', type: 'text' },
    { key: 'fullName', type: 'text' },
    { key: 'groupLib', type: 'text', isIconProfile: true },
    { key: 'role', type: 'text' },
    { key: 'email', type: 'text' },
    { key: 'phone', type: 'text' },
    { key: 'company', type: 'text' },
    { key: 'activity', type: 'text' },
    { key: 'siret', type: 'text' },
    { key: 'address', type: 'text' },
    { key: 'postalCode', type: 'text' },
    { key: 'city', type: 'text' },
    { key: 'agencyLib', type: 'text' },
    { key: 'sectorLib', type: 'text' },
    { key: 'discountPercentage', type: 'text', endAdornment: '%' },
    { key: 'isBan', type: 'banIcon' },
    { key: 'isVerified', type: 'validationButton', function: verifyUser },
    { key: 'isActivated', type: 'validationButton', function: activateUser },
    { key: 'createdAt', type: 'date' },
    { key: 'updatedAt', type: 'date' },
  ];

  // Configuration des filtres
  const filterConfig = [
    { key: 'groupLib', type: 'select', options: groupsFormatted, defaultValue: 'Client' },
    { key: 'company', type: 'select', options: companies},
  ];

  ErrorHandler(errorUser, clearUserErrors);

  useEffect(() => {
    if (userAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearUserSuccess());
    }
  }, [userAdded]);
  
  const getRowBackgroundColor = (rowData) => {
    const currentTheme = getCurrentTheme();
    if (rowData.isBan == true) {
      return (currentTheme == 'light')?'#ffe6e6':'#6e1414';
    }
    if (rowData.isVerified == false) {
      return (currentTheme == 'light')?'#fff2d1':'#784000';
    }
    return ''; 
  };

  return (

      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem={t("users")}/>
          
          <TableContainer
            columnConfig={columnConfig}
            filterConfig={filterConfig}
            data={users}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            isGlobalFilter={true}
            buttonClass="btn btn-primary btn-rounded waves-effect waves-light addContact-modal mb-2"
            buttonName="user"
            prefListName="user"
            totalKpi={{label: 'numberOfUsers', icon: 'mdi mdi-account-group-outline'}}
            isAddButton={true}
            linkToNew={'/users/new'}
            editFunction={openEditPage} 
            deleteFunction={deleteUserRequest}
            withBan={true}
            banFunction={banUserRequest}
            rowBackgroundColoring={true}
            rowColoringFunction={getRowBackgroundColor}
            defaultSortColumn={'fullName'}
            defaultSortDirection={'asc'}
          />
        </Container>
        <ToastContainer />
      </div>

  );
};

export default Users;
